jQuery( window ).scroll( function() {
  fixedHeader()
});

jQuery( window ).resize( function() {
  fixedHeader()
});

jQuery( document ).ready( function() {
  fixedHeader();
});

function fixedHeader() {
  if ( jQuery( window ).scrollTop() > 40 ) {
    jQuery('#header').addClass('fixed');
  } else {
    jQuery('#header').removeClass('fixed');
  }
}